// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
/** Matches the field-editor controls whose change saves the selected field. */
export const FIELD_EDITOR_SELECTS = "select, sp-select";
